import { c as _c } from "react/compiler-runtime";
import { urlForImage } from "@/sanity/lib/image";
import Image from "next/image";
import FadeIn from "./FadeIn";
import { Vimeo } from "./Vimeo";
import type { ProjectType } from "@/sanity/query/project";
type GalleryAsset = NonNullable<ProjectType["thumbnail"]> | ProjectType["content"][number];
type GridGalleryProps = {
  images: GalleryAsset[];
  title: string;
  onSelect: (index: number) => void;
};
export default function GridGallery(t0) {
  const $ = _c(9);
  const {
    images,
    title,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== images || $[1] !== onSelect || $[2] !== title) {
    let t2;
    if ($[4] !== onSelect || $[5] !== title) {
      t2 = (image, index) => <button key={image._type === "film" ? image.vimeo : image.url} type="button" className="contents min-w-0 cursor-pointer text-left" onPointerDown={_temp} onClick={event_0 => {
        event_0.stopPropagation();
        onSelect(index);
      }}>{image._type !== "film" ? <div className="relative mb-auto h-fit" style={{
          aspectRatio: image.metadata.dimensions.aspectRatio
        }}><Image src={urlForImage(image.url).width(800).maxHeight(800).url()} alt={title || "Project Image"} fill={true} sizes="(max-width: 639px) 50vw, 33vw" unoptimized={true} className="h-auto w-full" placeholder="blur" blurDataURL={image.metadata.lqip} /></div> : <FadeIn><Vimeo className="aspect-video w-full" value={image.vimeo} title={title || "Project Video"} /></FadeIn>}</button>;
      $[4] = onSelect;
      $[5] = title;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = images.map(t2);
    $[0] = images;
    $[1] = onSelect;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="grid grid-cols-2 gap-2 p-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(event) {
  return event.stopPropagation();
}